import { colorList } from '@/components/tools/setting';
import ASwitch from 'ant-design-vue/es/switch';
import AList from "ant-design-vue/es/list";
import AListItem from "ant-design-vue/es/list/Item";
import { mixin } from '@/utils/mixin.js';
var Meta = AListItem.Meta;
export default {
  components: {
    AListItem: AListItem,
    AList: AList,
    ASwitch: ASwitch,
    Meta: Meta
  },
  mixins: [mixin],
  data: function data() {
    return {};
  },
  filters: {
    themeFilter: function themeFilter(theme) {
      var themeMap = {
        'dark': '暗色',
        'light': '白色'
      };
      return themeMap[theme];
    }
  },
  methods: {
    colorFilter: function colorFilter(color) {
      var c = colorList.filter(function (o) {
        return o.color === color;
      })[0];
      return c && c.key;
    },
    onChange: function onChange(checked) {
      if (checked) {
        this.$store.dispatch('ToggleTheme', 'dark');
      } else {
        this.$store.dispatch('ToggleTheme', 'light');
      }
    }
  },
  render: function render() {
    var h = arguments[0];
    return h(AList, {
      "attrs": {
        "itemLayout": "horizontal"
      }
    }, [h(AListItem, [h(Meta, [h("a", {
      "slot": "title"
    }, ["\u98CE\u683C\u914D\u8272"]), h("span", {
      "slot": "description"
    }, ["\u6574\u4F53\u98CE\u683C\u914D\u8272\u8BBE\u7F6E"])]), h("div", {
      "slot": "actions"
    }, [h(ASwitch, {
      "attrs": {
        "checkedChildren": "暗色",
        "unCheckedChildren": "白色",
        "defaultChecked": this.navTheme === 'dark' && true || false
      },
      "on": {
        "change": this.onChange
      }
    })])]), h(AListItem, [h(Meta, [h("a", {
      "slot": "title"
    }, ["\u4E3B\u9898\u8272"]), h("span", {
      "slot": "description"
    }, ["\u9875\u9762\u98CE\u683C\u914D\u8272\uFF1A ", h("a", {
      "domProps": {
        "innerHTML": this.colorFilter(this.primaryColor)
      }
    })])])])]);
  }
};